import styled from 'styled-components'

import {
  title14Galano,
  title18Galano,
  title24GalanoBold,
  txt12OpenSans,
  txt12OpenSansLight,
  txt16OpenSans
} from '../../../styles/settings/types'

import { linkNavyBlue, darkGrey, lighterGrey, charcoal } from '../../../styles/settings/colors'

import media from '../../../styles/tools/media'
import rem from '../../../styles/tools/rem'

export const ModalWrapper = styled.div`
  padding: ${rem('24px')};
  width: 100%;

  ${media.large`
    max-height: 70vh;
    overflow-y: auto;
    padding: ${rem('32px')} ${rem('40px')};
  `};
`

export const DestaqueTitulo = styled.h2`
  ${title24GalanoBold} color: ${linkNavyBlue};
  margin: 0 0 ${rem('24px')};
`

export const ModalTitle = styled.h2`
  ${title18Galano} color: ${linkNavyBlue};
  margin: 0 0 ${rem('16px')};
`

export const TarifaRow = styled.div`
  align-items: flex-start;
  border-bottom: ${rem('1px')} solid ${lighterGrey};
  display: flex;
  justify-content: space-between;
  padding: ${rem('12px')} 0;

  :last-of-type {
    border-bottom: none;
  }
`

export const TarifaInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: ${rem('12px')};
`

export const TarifaTitulo = styled.span`
  ${title14Galano} color: ${charcoal};
`

export const TarifaDescricao = styled.span`
  ${txt12OpenSansLight} color: ${darkGrey};
  margin-top: ${rem('4px')};
`

export const TarifaValor = styled.span`
  ${txt16OpenSans} color: ${charcoal};
  font-weight: bold;
  text-align: right;
  white-space: nowrap;
`

export const TextoFinal = styled.p`
  ${txt12OpenSans} color: ${darkGrey};
  margin: ${rem('16px')} 0 0;

  ${media.large`
    margin: ${rem('24px')} 0 0;
  `};
`

export const TabelaRecargaLinha = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${rem('10px')} 0;
  border-bottom: ${rem('1px')} solid ${lighterGrey};

  :last-of-type {
    border-bottom: none;
  }
`

export const TabelaRecargaCelula = styled.span`
  ${txt12OpenSans} color: ${charcoal};
  flex: 1;
  text-align: ${props => props.align || 'left'};
`

export const TabelaRecargaCabecalho = styled(TabelaRecargaCelula)`
  ${title14Galano} color: ${linkNavyBlue};
  font-weight: bold;
`
